const disableButtons = (state = false, action) => {
    switch (action.type) {
        case 'DISABLE_BUTTONS':
            return action.flag;
        default:
            return state
    }
};

export default disableButtons
